<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData" />
                <div v-else>
                    <h4 class="text-error mb-2.5 font-normal">
                        {{ '您目前的保單「' + getIsAgreeBeforText() + '」續期保費未在寬限期屆滿前繳費時，依條款約定以保單價值準備金自動墊繳本契約及附約之保險費及利息。' }}
                    </h4>
                    <div class="border-t border-gray-100 text-base py-4 md:py-5">
                        <h4 class="text-secondary mb-2.5 font-bold">
                            請選擇欲辦理之內容
                        </h4>
                        <Radio
                            v-model:checkedValue="isAgree"
                            :value="'Y'"
                            text="同意"
                            :disabled="isAgreeBefor==='Y'"
                            class="mb-2.5 items-baseline"
                        />
                        <Radio
                            v-model:checkedValue="isAgree"
                            :value="'N'"
                            text="不同意"
                            :disabled="isAgreeBefor==='N'"
                            class="mb-2.5 items-baseline"
                        />
                    </div>
                    <div class="border-style">
                        <ol class="list-decimal text-base text-gray-700 ml-6 space-y-2">
                            <li>應補收自動墊繳保費本息僅供參考用，若保費未墊繳至保費應繳費相當日，則本次仍須再補收至保費應繳費相當日之天數保費。</li>
                            <li>實際應補收支金額將以Email或簡訊通知。</li>
                        </ol>
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="isAgree=='' || isAgree===isAgreeBefor || isGettingData"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getInfoC4, submitC4 } from '@/apis/C4';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
import Skeletons from '@/components/skeletons/Skeletons.vue';

export default {
    components: {
        Bottombar,
        Loading,
        Radio,
        ButtonNextService,
        Skeletons,
    },
    setup() {
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        /**
         * 正在取得資料
         */
        const isGettingData = ref(false);
        const isSubmitOk = ref(false);
        const isLoading = ref(false);
        const result = computed(() => store.state.services.changeItemsResult[code]);

        const isAgreeBefor = ref('N');
        /** 是否同意 */
        const isAgree = ref('');
        // 取得api資料
        const getData = () => {
            isGettingData.value = true;
            getInfoC4().then((res) => {
                isAgreeBefor.value = res.data.autoPremLoan;
            }).finally(() => {
                isGettingData.value = false;
            });
        };
        if (!result.value) {
            getData();
        } else {
            const { storeIsAgree, storeIsAgreeBefor } = result.value;
            isAgree.value = storeIsAgree;
            isAgreeBefor.value = storeIsAgreeBefor;
        }

        const getIsAgreeBeforText = () => {
            return isAgreeBefor.value === 'Y' ? '同意' : '不同意';
        };

        const saveAndgoNext = () => {
            isLoading.value = true;
            const returnData = {
                autoPremLoan: isAgree.value,
            };
            submitC4(returnData).then(() => {
                isSubmitOk.value = true;
                const value = {
                    storeIsAgree: isAgree.value,
                    storeIsAgreeBefor: isAgreeBefor.value
                };
                store.dispatch('services/setChangeItemsResult', { code, value });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        return {
            isGettingData,
            isLoading,
            isSubmitOk,
            isAgree,
            isAgreeBefor,
            getIsAgreeBeforText,
            saveAndgoNext,
        };
    },
};
</script>
